<template>
    <ModalHeader :title="title" :is-show-back-btn="false" :is_show_absolute_area="true">
        <template :slot="'absolute_area'">
            <div style="position:absolute; left:0px; height:100%; width:50px; display:flex; align-items: center;">
                <div style="font-size: 20px; width:50px;" @click="goBack">
                    <div style="width:38px; padding:0px 10px;">
                        <img :src="require('@/assets/img/back_btn.png')" style="width:9px;">
                        <!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>-->
                    </div>
                </div>
            </div>

            <div style="position: absolute; right:10px; bottom:5px; display:flex; ">

                <template v-if="$GlobalStore.isLogin()">
                    <div style="padding:7px 10px; color:white; font-weight:500;" @click="logout">로그아웃</div>
                </template>
                <template v-else>
                    <div style="padding:7px 10px; color:white; font-weight:500;" @click="showLogin(LOGIN_MODE.REGISTER)">회원가입</div>
                    <div style=" background-color:white; width:2px; margin:7px 0px;"></div>
                    <div style="padding:7px 10px; color:white; font-weight:500;" @click="showLogin(LOGIN_MODE.LOGIN)">로그인</div>
                </template>
            </div>
        </template>
    </ModalHeader>
</template>

<script>
    import ModalHeader from "./ModalHeader";
    import ResponseCode from "../../ResponseCode";
    import {LOGIN_MODE} from "../page/Login";

    export default {
        name: "LoginHeader",
        components: {ModalHeader},
        props : {
            is_show_title : {
                type : Boolean,
                default : true
            },
            is_show_back_btn : {
                type : Boolean,
                default : false
            },
            title : {
                type : String,
                default : ''
            },
        },
        data(){
            return {
                LOGIN_MODE : LOGIN_MODE
            }
        },
        methods : {
            goBack(){
                this.$GlobalRouter.push('/view/home?time=' + new Date().getTime())
            },
            showLogin(mode){
                this.$GlobalStore.addModal('Login', {mode : mode});
            },
            async logout(){
                this.$GlobalStore.showConfirm('정말로 로그아웃 하시겠습니까?', async () => {
                    const res = await this.$Axios.post('/api/logout');
                    if(res.data.code === ResponseCode.SUCCESS){
                        this.$GlobalStore.setLoginInfo(null);
                        this.$GlobalRouter.push('/view/home?time=' + new Date().getTime());
                    }else if(res.data.code === ResponseCode.FAIL){
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, '확인', '취소', async () => {})
            }
        }
    }
</script>

<style scoped>

</style>